import React from "react";
import { parseISO } from "date-fns";
import { ButtonSelect } from "../Select";
import Icon from "./sort-icon.svg";

function createSortFn(propName, transform = (val) => val, descending = false) {
    return (originalItems) => {
        const items = [].concat(originalItems);
        items.sort((a, b) => {
            const valA = a[propName] ?? transform(a[propName]);
            const valB = b[propName] ?? transform(b[propName]);
            if (valA < valB) {
                return descending ? 1 : -1;
            }
            if (valA > valB) {
                return descending ? -1 : 1;
            }
            return 0;
        });
        return items;
    };
}

const DESCENDING = true;

const SORT_CHOICES = [
    {
        // Should never be selected so will never be passed in the callback
        key: "A",
        label: "Sort By",
        disabled: true,
    },
    {
        key: "newest-oldest",
        label: "Newest - Oldest",
        sortFn: createSortFn("publishedDate", parseISO, DESCENDING),
    },
    {
        key: "oldest-newest",
        label: "Oldest - Newest",
        sortFn: createSortFn("publishedDate", parseISO),
    },
    //{ key: "whats-hot", label: "What's Hot", sortFn: (items) => items },
    {
        key: "a-z",
        label: "A - Z",
        sortFn: createSortFn("title", (t) => t.toLowerCase()),
    },
    {
        key: "z-a",
        label: "Z - A",
        sortFn: createSortFn("title", (t) => t.toLowerCase(), DESCENDING),
    },
];

export function SortBy({ value, onChange, ...rest }) {
    const onSelect = ({ key, label, sortFn }) => {
        onChange({ key, label }, sortFn);
    };

    return (
        <ButtonSelect
            icon={Icon}
            value={value ?? SORT_CHOICES[0]}
            options={SORT_CHOICES}
            onSelect={onSelect}
            {...rest}
        />
    );
}
